import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';

// Shared by the Suspense fallback and the loading state so both show the same
// thing. Height matches the loaded title so the page does not jump.
const PDPAvailableInSizesSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-3 md:mb-6 h-[25px] flex items-center" data-xc="available-sizes-loading"><Placeholder type="rect" loading={true} style={{
        width: "35%",
        height: 10
      }} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPAvailableInSizesSkeleton;